import { render, staticRenderFns } from "./c_news_roll.vue?vue&type=template&id=d1006f10&scoped=true&"
import script from "./c_news_roll.vue?vue&type=script&lang=js&"
export * from "./c_news_roll.vue?vue&type=script&lang=js&"
import style0 from "./c_news_roll.vue?vue&type=style&index=0&id=d1006f10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1006f10",
  null
  
)

export default component.exports